import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import HostingPage from "../pages/hosting/page";
import VpsPage from "../pages/vps/page";
import DominiosPage from "../pages/dominios/page";
import ServiciosPage from "../pages/servicios/page";
import SoporteGraciasPage from "../pages/soporte/gracias/page";
import EstadoServidoresPage from "../pages/soporte/estado-servidores/page";
import ContratarPage from "../pages/contratar/page";
import ContratarGraciasPage from "../pages/contratar/gracias/page";
import TerminosPage from "../pages/terminos/page";
import PrivacidadPage from "../pages/privacidad/page";

// Lazy-loaded pages with heavy mock data imports
const LazyBlogPage = lazy(() => import("@/pages/blog/page"));
const LazyBlogArticlePage = lazy(() => import("@/pages/blog/article/page"));
const LazySoportePage = lazy(() => import("@/pages/soporte/page"));
const LazySoporteArticuloPage = lazy(() => import("@/pages/soporte/articulo/page"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "hosting",
        element: <HostingPage />,
      },
      {
        path: "vps",
        element: <VpsPage />,
      },
      {
        path: "dominios",
        element: <DominiosPage />,
      },
      {
        path: "servicios",
        element: <ServiciosPage />,
      },
      {
        path: "blog",
        element: <LazyBlogPage />,
      },
      {
        path: "blog/:slug",
        element: <LazyBlogArticlePage />,
      },
      {
        path: "soporte",
        element: <LazySoportePage />,
      },
      {
        path: "soporte/articulo/:slug",
        element: <LazySoporteArticuloPage />,
      },
      {
        path: "soporte/gracias",
        element: <SoporteGraciasPage />,
      },
      {
        path: "soporte/estado-servidores",
        element: <EstadoServidoresPage />,
      },
      {
        path: "contratar",
        element: <ContratarPage />,
      },
      {
        path: "contratar/gracias",
        element: <ContratarGraciasPage />,
      },
      {
        path: "terminos",
        element: <TerminosPage />,
      },
      {
        path: "privacidad",
        element: <PrivacidadPage />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;